import { OrderByPipe } from './../pipes/orderby.pipe';
import { ResourceMappingComponent } from './../resource-mapping/resource-mapping.component';
import {
  MatNativeDateModule,
  NativeDateAdapter,
  DateAdapter,
  MatButtonModule,
  MatInputModule,
  MatSelectModule,
  MatProgressSpinnerModule,
  MatDialogModule,
  MatDatepickerModule
} from '@angular/material';
import {
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { 
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule } from 'devextreme-angular';
import { ModalComponent } from './../modal.component';
import { ProductImageUploadComponent } from './../image-admin/product-image-upload.component';
import { AccessoryDetailsComponent } from './containers/accessory-details/accessory-details.component';
import { ProductDetailsRelatedProductsComponent } from './components/product-details-related-products.component';
import { ProductDetailsModelsComponent } from './components/product-details-models.component';
import { ProductDetailsHeaderComponent } from './components/product-details-header.component';
import { ModelDetailsComponent } from './containers/model-details/model-details.component';
import { CarouselComponent } from './containers/carousel/carousel.component';
import {NgModule,CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProductCatContainerComponent} from './containers/product-cat.container.component';
import {ProductSliderContainerComponent} from './containers/product-slider.container.component';
import {CategorySelectionContainerComponent} from './containers/category-selection.container.component';
import {CategoryComponent} from './components/category/category.component';
import {HeaderComponent} from './components/header.component';
import {ProductCardComponent} from './components/product-card.component';
import {CommonModule} from '@angular/common';
import {ProductCategoryService} from './services/product-category.service';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule,ActivatedRoute} from '@angular/router';
import { SwiperModule } from 'angular2-useful-swiper';
import { ProductTypeDetailsComponent } from './containers/product-type-details/product-type-details.component';
import { ProductDetailsDetailsComponent } from './components/product-details-details.component';
import { ModelDetailsDetailsComponent } from './components/model-details-details.component';
import { ModelDetailsCarouselComponent } from './components/model-details-carousel.component';
import { ModelDetailsResourcesComponent } from './components/model-details-resources.component';
import { ModelDetailsRelatedProductsComponent } from './components/model-details-related-products.component';
import { ModelDetailsRebateComponent } from './components/eco-rebates/model-details-rebate.component';
import { ZipCodeComponent } from './components/eco-rebates/zip-code-component/zip-code-component';
import { AccessoryDetailsCarouselComponent } from './components/accessory-details-carousel.component';
import { AccessoryDetailsDetailsComponent } from './components/accessory-details-details.component';
import { AccessoryDetailsHeadersComponent } from './components/accessory-details-headers.component';
import { MomentDateAdapter } from './../date-adapter/moment-date-adapter.class';
import { MOMENT_DATE_FORMATS } from './../date-formats/moment-date-formats';
import { ResourcesComponent } from '../resources/components/resources.component';
import { SearchResultComponent } from '../search-results/search-result.component';
import { LocatorComponent  } from './components/locator/locator.component';
import {ResourcesModule} from '../resources/resources.module';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import {ProductDetailsRebateComponent} from './components/product-details-rebate.component';
import { professionalLocatorService } from './services/professional-locator.service';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@NgModule({
  imports: [
    CommonModule,
    SwiperModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    MatNativeDateModule
  ],
  declarations: [
    ProductCatContainerComponent,
    ProductSliderContainerComponent,
    CategorySelectionContainerComponent,
    OrderByPipe,
    CarouselComponent,
    CategoryComponent,
    HeaderComponent,
    ProductCardComponent,
    ProductTypeDetailsComponent,
    ModelDetailsComponent,
    ProductDetailsHeaderComponent,
    ProductDetailsDetailsComponent,
    ProductDetailsModelsComponent,
    ProductDetailsRebateComponent,
    ProductDetailsRelatedProductsComponent,
    ModelDetailsDetailsComponent,
    ModelDetailsCarouselComponent,
    ModelDetailsResourcesComponent,
    ModelDetailsRelatedProductsComponent,
    ModelDetailsRebateComponent,
    AccessoryDetailsComponent,
    AccessoryDetailsCarouselComponent,
    AccessoryDetailsDetailsComponent,
    AccessoryDetailsHeadersComponent,
    ProductImageUploadComponent,
    ModalComponent,
    ResourceMappingComponent,
    SearchResultComponent,
    LocatorComponent,
    SafePipe,
    ZipCodeComponent
  ],
  providers: [ProductCategoryService,professionalLocatorService, HttpClientModule, OrderByPipe,
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS }]
  ,
  exports: [CategorySelectionContainerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProductCategoryModule {}



// WEBPACK FOOTER //
// ./src/app/product-category/product-category.module.ts